import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/crazy-weekend',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CrazyWeekend" */ '~/pages/CrazyWeekend/pages/home/Container'
        )
    ),
  },
  {
    path: '/crazy-weekend/return-bonus',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CrazyWeekend-return-bonus" */ '~/pages/CrazyWeekend/pages/return-bonus-activity'
        )
    ),
  },
] as RouteConfig[]
